import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login } from '../../store/slices/authSlice';
import bgImage from "../../assets/images/bg-sign-in-basic.jpeg";
import axiosInstance from '../../config/axiosConfig';
import { getDefaultRoute } from '../../helper/permissions';

const SignIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleSignIn = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setLoading(true);

    try {
      const response = await axiosInstance.post('users/login', {
        email,
        password,
      });

      const { token, user } = response?.data?.data || {};
      if (token) {
        dispatch(login({ token, user }));
        navigate(getDefaultRoute(user));
      }
    } catch (error) {
      console.error('Error signing in:', error);
      setErrorMessage(
        error.response?.data?.message || 'Failed to sign in. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '0.75rem',
    borderRadius: '4px',
    border: '1px solid #ccc',
    boxSizing: 'border-box',
    display: 'block',
    fontSize: '1rem',
  };

  return (
    <div
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
        width: '100%',
        margin: 0,
        padding: '1.5rem',
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          padding: '2rem',
          borderRadius: '8px',
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)',
          width: '100%',
          maxWidth: '400px',
          margin: '0 auto',
          boxSizing: 'border-box',
        }}
      >
        <h2
          style={{
            textAlign: 'center',
            margin: '0 0 1.5rem',
            fontWeight: 600,
            color: '#1a1a1a',
          }}
        >
          Sign In
        </h2>
        <form onSubmit={handleSignIn} style={{ width: '100%' }}>
          <div style={{ marginBottom: '1rem' }}>
            <label
              htmlFor="email"
              style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: 500,
              }}
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              style={inputStyle}
            />
          </div>
          <div style={{ marginBottom: '1.25rem' }}>
            <label
              htmlFor="password"
              style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: 500,
              }}
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              style={inputStyle}
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '0.75rem',
              borderRadius: '4px',
              border: 'none',
              backgroundColor: '#007bff',
              color: '#fff',
              fontWeight: 'bold',
              cursor: loading ? 'wait' : 'pointer',
              boxSizing: 'border-box',
              fontSize: '1rem',
              opacity: loading ? 0.85 : 1,
            }}
          >
            {loading ? (
              <span
                style={{
                  display: 'inline-block',
                  width: '1rem',
                  height: '1rem',
                  border: '2px solid white',
                  borderRadius: '50%',
                  borderRightColor: 'transparent',
                  animation: 'uo-signin-spin 1s linear infinite',
                  verticalAlign: 'middle',
                }}
              />
            ) : (
              'Sign In'
            )}
          </button>
        </form>
        {errorMessage && (
          <p
            style={{
              color: '#c0392b',
              marginTop: '1rem',
              marginBottom: 0,
              textAlign: 'center',
              fontSize: '0.9rem',
            }}
          >
            {errorMessage}
          </p>
        )}
      </div>
      <style>
        {`
          @keyframes uo-signin-spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default SignIn;
